export { addGlobalEventProcessor, Scope } from './scope';
export { Session } from './session';
export { getActiveDomain, getCurrentHub, getHubFromCarrier, getMainCarrier, Hub, makeMain, setHubOnCarrier, } from './hub';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/hub/esm/index.js
// module id = 20
// module chunks = 0